import {
    SECTION_EQUIPMENT_AREA,
    SECTION_EQUIPMENT_AREA_SUCCESS,
    SECTION_EQUIPMENT_AREA_ERROR,
    SECTION_EQUIPMENT_COMPLEXITY,
    SECTION_EQUIPMENT_COMPLEXITY_SUCCESS,
    SECTION_EQUIPMENT_COMPLEXITY_ERROR,
    SECTION_EQUIPMENT_EQUIPMENT,
    SECTION_EQUIPMENT_EQUIPMENT_SUCCESS,
    SECTION_EQUIPMENT_EQUIPMENT_ERROR,
    SECTION_EQUIPMENT_LIST,
    SECTION_EQUIPMENT_LIST_SUCCESS,
    SECTION_EQUIPMENT_LIST_ERROR,
    SECTION_EQUIPMENT_ADD,
    SECTION_EQUIPMENT_ADD_SUCCESS,
    SECTION_EQUIPMENT_ADD_ERROR,
    SECTION_EQUIPMENT_ADD_CHANGE,
    SECTION_EQUIPMENT_EDIT_CHANGE,
    SECTION_EQUIPMENT_UPDATE,
    SECTION_EQUIPMENT_UPDATE_SUCCESS,
    SECTION_EQUIPMENT_UPDATE_ERROR
} from '../../actions';

const INIT_STATE = {
    loading: true,
    file: [],
    list: {
        header: {
            name: 'code',
            order: 'sorted-asc'
        },
        page: {
            current: 1,
            rows: 1000
        }
    },
    area: {
        loading: false,
        data: []
    },
    complexity: {
        loading: false,
        data: []
    },
    equipment: {
        loading: false,
        data: []
    },
    add: {
        data: {
            new: { id_section_equipment: null, area:null, complexity:null, equipment:null, code_section_equipment:'' }
        },
        modal: false,
        loading: false,
        message: '',
        url: '',
        type: ''
    },
    edit: {
        loading: true,
        data: {
            new: [],
            old: []
        },
        modal: false,
        update: {
            loading: false,
            response: '',
            message: ''
        }
    },
    error: false
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case SECTION_EQUIPMENT_AREA:
            return {
                ...state,
                loading: true,
                area: {
                    ...state.area
                }
            }
        case SECTION_EQUIPMENT_AREA_SUCCESS:
            return {
                ...state,
                loading: false,
                area: {
                    ...state.area,
                    ...action.payload
                }
            }
        case SECTION_EQUIPMENT_AREA_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case SECTION_EQUIPMENT_COMPLEXITY:
            return {
                ...state,
                loading: true,
                complexity: {
                    ...state.complexity
                }
            }
        case SECTION_EQUIPMENT_COMPLEXITY_SUCCESS:
            return {
                ...state,
                loading: false,
                complexity: {
                    ...state.complexity,
                    ...action.payload
                }
            }
        case SECTION_EQUIPMENT_COMPLEXITY_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case SECTION_EQUIPMENT_EQUIPMENT:
            return {
                ...state,
                loading: true,
                equipment: {
                    ...state.equipment
                }
            }
        case SECTION_EQUIPMENT_EQUIPMENT_SUCCESS:
            return {
                ...state,
                loading: false,
                equipment: {
                    ...state.equipment,
                    ...action.payload
                }
            }
        case SECTION_EQUIPMENT_EQUIPMENT_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case SECTION_EQUIPMENT_LIST:
            return {
                ...state,
                loading: true,
                list: {
                    ...state.list
                }

            }
        case SECTION_EQUIPMENT_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                list: {
                    ...state.list,
                    ...action.payload
                }
            }
        case SECTION_EQUIPMENT_LIST_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case SECTION_EQUIPMENT_ADD_CHANGE:
            return {
                ...state,
                add: {
                    ...state.add,
                    data: {
                        ...state.add.data,
                        new: {
                            ...state.add.data.new,
                            ...action.payload
                        }
                    }
                }
            }
        case SECTION_EQUIPMENT_ADD:
            return {
                ...state,
                add: {
                    ...state.add,
                    loading: true
                }
            }
        case SECTION_EQUIPMENT_ADD_SUCCESS:
            return {
                ...state,
                add: {
                    ...state.add,
                    modal: false,
                    loading: false,
                    message: action.payload.message
                },
                list: {
                    ...state.list,
                    ...action.payload
                }
            }
        case SECTION_EQUIPMENT_ADD_ERROR:
            return {
                ...state,
                add: {
                    ...state.add,
                    loading: false,
                    message: action.payload.message
                }
            }
        case SECTION_EQUIPMENT_EDIT_CHANGE:
            return {
                ...state,
                edit: {
                    ...state.edit,
                    data: {
                        ...state.edit.data,
                        new: {
                            ...state.edit.data.new,
                            ...action.payload
                        }
                    }
                }
            }
        case SECTION_EQUIPMENT_UPDATE:
            return {
                ...state,
                edit: {
                    ...state.edit,
                    data: {
                        ...state.edit.data,
                        ...action.payload,
                    },
                    update: { 
                        ...state.update,
                        loading: true,
                        response: '',
                        message: ''
                    }
                }
            }
        case SECTION_EQUIPMENT_UPDATE_SUCCESS:
            return {
                ...state,
                edit: {
                    ...state.edit,
                    modal: false,
                    loading: false,
                    url: action.payload.url,
                    type: action.payload.type,
                    message: action.payload.message,
                    update: {
                      ...state.update,
                      loading: false,
                      response: 'success',
                      message: action.payload
                    }
                },
                list: {
                    ...state.list,
                    ...action.payload
                }
            }
        case SECTION_EQUIPMENT_UPDATE_ERROR:
            return {
                ...state,
                edit: {
                    ...state.edit,
                    update: {
                        ...state.update,
                        loading: false,
                        response: 'error',
                        message: action.payload
                    }
                }
            }
        default:
            return { ...state };
    }

};